import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import { GamificationEndpoints } from '@space-shell/common/services/gamification'
import { APP_SPACE_HOT_HTTP_INSTANCES } from '@space-shell/config/request/providers/hotClubHttp/constants'
import { useMembershipStore } from '@space-shell/core/store'

const useGamificationToggle = () => {
  const { membershipData } = useMembershipStore()
  const { authStatus } = useAuthContext()
  const isUserAuthenticated = Boolean(authStatus === AuthStatus.AUTHENTICATED)
  const membershipId = membershipData?.id || ''

  const URL = GamificationEndpoints.gamificationToggle(membershipId)

  return useHotRequest<boolean>(URL, {
    instanceName: APP_SPACE_HOT_HTTP_INSTANCES.API_CONTENT_GATEWAY,
    cacheKey: [URL],
    queryOptions: {
      enabled: Boolean(membershipId && isUserAuthenticated)
    }
  })
}

export default useGamificationToggle
